// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"845e2f3c","703":"bb2b1812","787":"443d220e"}[chunkId] + ".chunk.js";
};